/* eslint-disable no-param-reassign */
import Vue from 'vue';

const userDef = {
  email: null,
};

export default {
  namespaced: true,

  state: {
    accessError: 0,
    connected: false,
    user: { ...userDef },
    show: false,
  },

  getters: {
    user: state => state.user,
    connected: state => state.connected,
    accessError: state => state.accessError,
    show: state => state.show,
  },

  mutations: {
    logout(state) {
      state.connected = false;
      state.user = { ...userDef };
    },

    accessError(state) {
      state.accessError += 1;
    },

    user(state, data) {
      state.user = data.user;
      state.connected = true;
    },

    show(state, data) {
      data = data || {};
      state.show = data.show !== undefined ? !!data.show : true;
    },
  },

  actions: {
    async getToken(ctx, data) {
      return Vue.prototype.$api.post('/auth/sessions', { ...data.auth });
    },

    async refreshToken(ctx, data) {
      if (data && data.useHttp) {
        // utilisé dans l'errorInterceptor axios, pour éviter
        // une boucle infinie
        return Vue.prototype.$http.post(`${Vue.prototype.$api.defaults.baseURL}/auth/issuetoken`);
      }

      return Vue.prototype.$api.post('/auth/issuetoken');
    },

    async logout(context) {
      return Vue.prototype.$api.delete('/auth/sessions/current')
        .finally(() => context.commit('logout'));
    },

    async loadUser(context) {
      const res = await Vue.prototype.$api.get('/me');
      context.commit('user', { user: res.data });
      return res.data;
    },
  },
};
